module.exports = __webpack_public_path__ + "static/media/how-it-works-1.a806d185.png";